/* eslint-disable max-len */
/* eslint-disable no-restricted-globals */
import { dwmRepository } from 'common/repositories/index';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';

const _serviceDependencies = ['$scope', '$http', '$rootScope', 'Util', 'dwmValidations'];

class DwmBankAccounts {

    constructor($scope, $http, $rootScope, Util, dwmValidations) {

        $scope.ibanIsValid = true;
        $scope.bankNameIsValid = true;
        $scope.bankAccountNumberIsValid = true;
        $scope.bankAccountNumberIsNumeric = true;

        const validations = dwmValidations;

        const onDwmDataNext = () => {

            const assets = dwmRepository.getAll('assets') || {};
            if (assets.primaryMember) {

                $scope.bankAccounts = assets.primaryMember.monitoredAccounts.bankAccounts;

                $scope.bankAccounts.entries.forEach((entry) => {

                    entry.showUpdateInput = false;

                });

            }

        };

        const dwmRepositoryObservable = dwmRepository.getObservable();
        dwmRepositoryObservable
            .subscribe(
                data => onDwmDataNext(data),
                () => { },
                () => { },
            );

        $scope.newEntryVisible = false;
        $scope.showAddNewButton = true;
        $scope.showSaveButton = false;
        $scope.showRemoveEntryScreen = false;
        $scope.showUpdateButton = false;

        $scope.addNewEntry = () => {

            $scope.newEntryVisible = true;
            $scope.showAddNewButton = false;
            $scope.showSaveButton = true;
            setTimeout(() => {

                angular.element('.update-bank-name').trigger('focus');

            }, 100);

        };

        $scope.cancelNewEntry = () => {

            $scope.ibanIsValid = true;
            $scope.bankNameIsValid = true;
            $scope.bankAccountNumberIsValid = true;
            $scope.bankAccountNumberIsNumeric = true;
            $scope.newEntryVisible = false;
            $scope.showAddNewButton = true;
            $scope.showSaveButton = false;
            $scope.newIban = '';
            $scope.newBankName = '';
            $scope.newBankAccountNumber = '';
            $scope.newEntrySubmitted = false;

        };

        $scope.updateEntry = (index) => {

            $scope.newEntryVisible = false;
            $scope.showAddNewButton = false;
            $scope.showSaveButton = false;
            $scope.showUpdateButton = true;

            $scope.bankAccounts.entries.forEach((entry, loopIndex) => {

                if (index === loopIndex) {

                    entry.showUpdateInput = true;
                    $scope.updateEntryPayload = entry;

                    // Save initial entry values to use in case of update is canceled
                    $scope.initialIban = entry.iban;
                    $scope.initialBankName = entry.name;
                    $scope.intialBankAccountNumber = entry.accountNumber;
                    $scope.initialEntryIndex = loopIndex;

                } else {

                    entry.showUpdateInput = false;

                }

            });

            setTimeout(() => {

                angular.element('.update-bank-name').trigger('focus');

            }, 100);

        };

        $scope.cancelUpdateNewEntry = () => {

            $scope.ibanIsValid = true;
            $scope.bankNameIsValid = true;
            $scope.bankAccountNumberIsValid = true;
            $scope.bankAccountNumberIsNumeric = true;
            $scope.showAddNewButton = true;
            $scope.showUpdateButton = false;

            $scope.bankAccounts.entries.forEach((entry) => {

                entry.showUpdateInput = false;

            });

            $scope.updateEntryPayload = {};

            // Revert changes of the selected entry
            $scope.bankAccounts.entries[$scope.initialEntryIndex].name =
                $scope.initialBankName;
            $scope.bankAccounts.entries[$scope.initialEntryIndex].iban =
                $scope.initialIban;
            $scope.bankAccounts.entries[$scope.initialEntryIndex].accountNumber =
                $scope.intialBankAccountNumber;

        };

        $scope.validateBankName = ($event) => {

            if ($scope.newEntrySubmitted) {

                $scope.bankNameIsValid = $event.currentTarget.value &&
                    validations.bankNameValidator($event.currentTarget.value.trim());

            }

            $scope.newBankName = $event.currentTarget.value;

        };

        $scope.validateiban = ($event) => {

            if ($scope.newEntrySubmitted) {

                $scope.ibanIsValid = $event.currentTarget.value &&
                    validations.ibanValidator($event.currentTarget.value.trim());

            }

            $scope.newIban = $event.currentTarget.value;

        };

        $scope.validateBankAccountNumber = ($event) => {

            if ($scope.newEntrySubmitted) {

                if ($event.currentTarget.value.length) {

                    $scope.bankAccountNumberIsValid = $event.currentTarget.value && validations.bankAccountNumberValidator($event.currentTarget.value.trim());
                    $scope.bankAccountNumberIsNumeric = $event.currentTarget.value && /^\d+$/.test($event.currentTarget.value.trim());

                } else {

                    $scope.bankAccountNumberIsValid = true;
                    $scope.bankAccountNumberIsNumeric = true;

                }

            }

            $scope.newBankAccountNumber = $event.currentTarget.value;

        };

        $scope.saveNewEntry = () => {

            $scope.ibanIsValid = $scope.newIban === undefined ? false : validations.ibanValidator($scope.newIban.trim());


            $scope.bankNameIsValid = $scope.newBankName === undefined ? false : validations.bankNameValidator($scope.newBankName.trim());


            if ($scope.newBankAccountNumber) {

                $scope.bankAccountNumberIsValid = validations.bankAccountNumberValidator($scope.newBankAccountNumber.trim());
                $scope.bankAccountNumberIsNumeric = $scope.newBankAccountNumber === undefined ? false : /^\d+$/.test($scope.newBankAccountNumber.trim());

            } else {

                $scope.bankAccountNumberIsValid = true;

            }

            $scope.newEntrySubmitted = true;

            if ($scope.ibanIsValid && $scope.bankAccountNumberIsValid && $scope.bankNameIsValid) {

                $scope.saveNewBankAccountIsLoading = true;

                const payload = {
                    bankAccounts: {
                        iban: $scope.newIban,
                        name: $scope.newBankName,
                        accountNumber: $scope.newBankAccountNumber,
                        type: 'OTHER',
                    },
                };
                $http({
                    method: 'POST',
                    url: `${CWCONFIG.dwm.restApi}/v1/modifyAccount`,
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json',
                    },
                    data: payload,

                }).then(() => {

                    $scope.newIban = '';
                    $scope.newBankName = '';
                    $scope.newBankAccountNumber = '';
                    $scope.saveNewBankAccountIsLoading = false;

                    $http({
                        method: 'GET',
                        url: `${CWCONFIG.dwm.restApi}/v1/partner/members`,
                        headers: {
                            client_id: 'avira',
                            origin: 'https://avira.com',
                            access_token: $rootScope.dwmNortonToken,
                            'Content-Type': 'application/json',
                        },

                    }).then((membersResponse) => {

                        dwmRepository.replace('assets', membersResponse.data);

                        const { monitoredAccounts, dwmCardStatus } = membersResponse.data.primaryMember;
                        Mixpanel.setCommonProperty('AIA Asset Bank Account', monitoredAccounts.bankAccounts.entries.length);

                        Mixpanel.send('ConnectWeb AIA Entry Action Success', {
                            Action: 'Add',
                            Entry: 'Bank accounts',
                        });

                        if (dwmCardStatus === 'add-more-data') {

                            $rootScope.showDwmCardHomepage = true;
                            $rootScope.showDwmAddMoreDataCard = true;

                        } else {

                            $rootScope.showDwmCardHomepage = false;

                        }

                        $scope.cancelNewEntry();

                    });

                }).catch((responseError) => {

                    $scope.saveNewBankAccountIsLoading = false;

                    if (responseError.data.errorCode === 4013) {

                        Alert.error('cw.dwm.dupliacte_entry_error');

                    } else {

                        Alert.error(
                            { message: 'cw.recommendation.error.connection_failed' },
                            {
                                message: {
                                    brandname: CWCONFIG.partnerConfig.name,
                                    url: '/dashboard/support/tabs/support',
                                },
                            },
                        );

                    }

                });

            }

        };

        $scope.removeEntry = (index) => {

            $scope.showRemoveEntryScreen = true;
            $scope.cancelNewEntry();

            $scope.removeEntryPayload = {
                bankAccounts:
                {
                    id: $scope.bankAccounts.entries[index].id,
                },
            };

        };

        $scope.confirmRemoveEntry = () => {

            $scope.confirmRemoveIsLoading = true;

            $http({
                method: 'DELETE',
                url: `${CWCONFIG.dwm.restApi}/v1/modifyAccount?payload=${encodeURIComponent(JSON.stringify($scope.removeEntryPayload))}`,
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json',
                },
            }).then(() => {

                $scope.newIban = '';
                $scope.newBankName = '';
                $scope.newBankAccountNumber = '';

                $http({
                    method: 'GET',
                    url: `${CWCONFIG.dwm.restApi}/v1/partner/members`,
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json',
                    },

                }).then((membersResponse) => {

                    dwmRepository.replace('assets', membersResponse.data);

                    const { monitoredAccounts, dwmCardStatus } = membersResponse.data.primaryMember;
                    Mixpanel.setCommonProperty('AIA Asset Bank Account', monitoredAccounts.bankAccounts.entries.length);

                    Mixpanel.send('ConnectWeb AIA Entry Action Success', {
                        Action: 'Delete',
                        Entry: 'Bank accounts',
                    });

                    if (dwmCardStatus === 'add-more-data') {

                        $rootScope.showDwmCardHomepage = true;
                        $rootScope.showDwmAddMoreDataCard = true;

                    } else {

                        $rootScope.showDwmCardHomepage = false;

                    }

                    $scope.confirmRemoveIsLoading = false;
                    $scope.cancelRemoveEntry();
                    $scope.cancelUpdateNewEntry();

                });

            }).catch((responseError) => {

                $scope.confirmRemoveIsLoading = false;

                if (responseError.data) {

                    Alert.error(
                        { message: 'cw.recommendation.error.connection_failed' },
                        {
                            message: {
                                brandname: CWCONFIG.partnerConfig.name,
                                url: '/dashboard/support/tabs/support',
                            },
                        },
                    );

                }

            });

        };

        $scope.cancelRemoveEntry = () => {

            $scope.showRemoveEntryScreen = false;
            $scope.removeEntryPayload = {};

        };

        $scope.updateBankName = ($event) => {

            $scope.bankNameIsValid = $event.currentTarget.value &&
                validations.bankNameValidator($event.currentTarget.value.trim());

            if ($scope.bankNameIsValid) {

                $scope.updateEntryPayload.name = $event.currentTarget.value;

            }

        };

        $scope.updateiban = ($event) => {

            $scope.ibanIsValid = $event.currentTarget.value &&
                validations.ibanValidator($event.currentTarget.value.trim());

            if ($scope.ibanIsValid) {

                $scope.updateEntryPayload.iban = $event.currentTarget.value;

            }

        };

        $scope.updateBankAccountNumber = ($event) => {

            $scope.bankAccountNumberIsValid = $event.currentTarget.value && validations.bankAccountNumberValidator($event.currentTarget.value.trim());
            $scope.bankAccountNumberIsNumeric = $event.currentTarget.value && /^\d+$/.test($event.currentTarget.value.trim());

            if ($scope.bankAccountNumberIsValid) {

                $scope.updateEntryPayload.accountNumber = $event.currentTarget.value;

            }

        };

        $scope.saveUpdatedEntry = () => {

            $scope.saveUpdatedEntryIsLoading = true;

            $http({
                method: 'PUT',
                url: `${CWCONFIG.dwm.restApi}/v1/modifyAccount`,
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json',
                },
                data: { bankAccounts: $scope.updateEntryPayload },
            }).then(() => {

                Mixpanel.send('ConnectWeb AIA Entry Action Success', {
                    Action: 'Update',
                    Entry: 'Bank accounts',
                });

                $scope.showAddNewButton = true;
                $scope.showUpdateButton = false;
                $scope.updateEntryPayload = {};
                $scope.saveUpdatedEntryIsLoading = false;

                $http({
                    method: 'GET',
                    url: `${CWCONFIG.dwm.restApi}/v1/partner/members`,
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json',
                    },

                }).then((membersResponse) => {

                    dwmRepository.replace('assets', membersResponse.data);
                    $scope.confirmRemoveIsLoading = false;

                });

            }).catch((responseError) => {

                $scope.saveUpdatedEntryIsLoading = false;

                if (responseError.data.errorCode === 4013) {

                    Alert.error('cw.dwm.dupliacte_entry_error');

                } else {

                    Alert.error(
                        { message: 'cw.recommendation.error.connection_failed' },
                        {
                            message: {
                                brandname: CWCONFIG.partnerConfig.name,
                                url: '/dashboard/support/tabs/support',
                            },
                        },
                    );

                }

            });

        };

    }

}

_serviceDependencies.push(DwmBankAccounts);

angular.module('controllers')
    .controller('DwmBankAccounts', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/controllers/modals/dwm/bank-accounts/bank-accounts.js